module.exports = __webpack_public_path__ + "static/media/5DPO4.bd2f8ef9.jpg";